import React from 'react'
import { useSelector } from 'react-redux'
import { useInView } from 'react-intersection-observer'

import DocCard from './cards/docCard'
import EventCard from './cards/eventCard'
import NewsCard from './cards/newsCard'
import Slider from './slider'
import ButtonArrow from './buttonArrow'

import trads from '../intl/trads.json'
import GetNewsroomUrls from '../utils/getNewsroomUrls'

const SliderContent = ({items, contentType, title = false, title2 = false, hasCta = true}) => {
  const lang = useSelector(state => state.lang)
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const newsroomUrls = GetNewsroomUrls()

  let ctaText, ctaUrl

  if (hasCta) {
    switch(contentType) {
      case 'press':
        ctaText = trads[lang].search.linkContentTypes.press
        ctaUrl = `/${newsroomUrls['Communiqués de presse'][lang]}`
        break
      case 'publi':
        ctaText = trads[lang].search.linkContentTypes.doc
        ctaUrl = `/${newsroomUrls['Publications'][lang]}`
        break
      case 'event':
        ctaText = trads[lang].search.linkContentTypes.event
        ctaUrl = `/${newsroomUrls['Événements'][lang]}`

        break
      default:
        ctaText = false
    }
  }

  const renderContent = (item) => {
    switch(contentType) {
      case 'press':
        return (
          <DocCard 
            document={item}
            smallTitle={true}
            isPressRelease={true} />
        )
      case 'publi':
        return (
          <DocCard 
            document={item}
            smallTitle={true} />
        )
      case 'event':
        return (
          <EventCard 
            event={item} />
        )
      case 'news':
        return (
          <NewsCard 
            news={item} />
        )
      default:
        return 'error'
    }
  }

  return (
    <section className={`slice ${inView ? 'has-anim' : ''} `} ref={ref}>
      { title &&
        <h2 className="title title-slice slider-cards-title">
          {title}
          { title2 &&
            <span className="font-normal block">{title2}</span>
          }
        </h2>
      }
      <div className="slider-cards">
        <Slider
          name="newsroom-featured" 
          hasCards="true"
          nbItems={items.length}
          options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 2, "slidesPerGroup": 2, "spaceBetween": 32 }, "1280": { "slidesPerView": 3, "slidesPerGroup": 3, "spaceBetween": 32 }} }'>

          {items.length > 0 && items.map((item, i) => {
            return (
              <div className={`scroll-anim-el w-full flex scroll-anim-el--${i + 1}`} key={i}>
                { renderContent(item) }
              </div>
            )
          })}
        </Slider>
      </div>
      { hasCta &&
        <div className="scroll-anim-el scroll-anim-el--4">
          <ButtonArrow 
            text={ctaText}
            link={ctaUrl}
            color="night" />
        </div>
      }
    </section>
  )
}

export default SliderContent